import { SET_CRITICAL_DEVIATIONS, DeviationsList } from 'types/DeviationTypes';

const initialState = [];

export default function deviationsReducer(state = initialState, action): DeviationsList {
  if (action.type === SET_CRITICAL_DEVIATIONS) return action.payload;
  return state;
}
